const getAuthDomain = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost') return 'valyss-88dcc.firebaseapp.com';
  if (hostname.includes('artpingpong.com')) return 'artpingpong.com';
  if (hostname.includes('valyss.com')) return 'app.valyss.com';
  if (hostname.includes('domoreworld.com')) return 'app.domoreworld.com';
  return import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
};

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: getAuthDomain(),
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export default { firebase: firebaseConfig };
